import React from "react";
import { motion } from "framer-motion";
import { Linkedin, Instagram, Youtube, Mail } from "lucide-react";

const ICONS = {
  LinkedIn: Linkedin,
  Instagram: Instagram,
  YouTube: Youtube,
  Email: Mail,
};

export default function SocialRail({ socials = [] }) {
  if (!socials.length) return null;
  return (
    <motion.div
      data-testid="social-rail"
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ delay: 1.1, duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className="fixed right-4 lg:right-6 top-1/2 -translate-y-1/2 z-40 hidden md:flex flex-col items-center gap-4"
    >
      <span className="h-16 w-px bg-[#2a2a2a]" />
      {socials.map((s) => {
        const Icon = ICONS[s.label] || Mail;
        return (
          <a
            key={s.label}
            href={s.url}
            target={s.url.startsWith("mailto:") ? undefined : "_blank"}
            rel="noreferrer"
            aria-label={s.label}
            title={s.label}
            data-testid={`rail-${s.label.toLowerCase()}`}
            className="group h-10 w-10 flex items-center justify-center border border-[#242424] text-[#a3a3a3] hover:text-[#050505] hover:bg-[#FAFAFA] hover:border-[#FAFAFA] transition-colors duration-300"
          >
            <Icon size={17} className="transition-transform duration-300 group-hover:scale-110" />
          </a>
        );
      })}
      <span className="h-16 w-px bg-[#2a2a2a]" />
    </motion.div>
  );
}
